<template>
  <div class="leads">
    <gnetHeader></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

    <gnet-card v-bind:title="'Cataloghi'" v-bind:object="'quotes'" v-bind:actions="headlineActions" v-on:click="actionClick($event)" v-bind:nospace="false"></gnet-card>

    <gnetTable
      v-bind:cols="cols"
      v-bind:records="records"
      v-on:click="gotoRecord($event)"
      v-on:filter="filter($event)"
      v-on:sort="changeSort($event)"
    >      
    </gnetTable>

    <gnetModal
      v-if="filterPanel.show"
      v-bind:title="'Applica filtro'"
      v-bind:object="'lead'"
      v-on:cancel="filterPanel.show=false"
      v-on:submit="doFilter"
    >
        <label class="slds-form-element__label" v-bind:for="'form-element-1'">{{filterPanel.name}}</label>

        <div class="slds-form-element__control">
          <input v-model="filterPanel.value" type="text" id="form-element-2" placeholder="filtro..." class="slds-input" />
        </div>
    </gnetModal>

    <gnetModal
      v-if="showModaleQuote"
      v-bind:title="'Inserisci il titolo del catalogo'"
      v-bind:object="'quotes'"
      v-on:cancel="showModaleQuote=false"
      v-on:submit="createQuote()">
        <div class="slds-form-element__control">
          <input v-model="titoloQuote" type="text" id="form-element-2" placeholder="Titolo..." class="slds-input" />
        </div>
    </gnetModal>

    <gnetSpinner v-bind:busy="busy"></gnetSpinner>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetTable from '../components/table.vue'
import gnetModal from '../components/modal.vue'
import gnetCard from '../components/card.vue'
import gnetTicket from '../components/ticket.vue'
import gnetSpinner from '../components/spinner.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
//import numeral from 'numeral'
import moment from 'moment'
import mustache from 'mustache'

export default {
  name: 'Cataloghi',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTable,
    gnetSpinner,
    gnetTicket,
    gnetModal,
    gnetCard
  },
  data: function() {
    return {
      busy: false,
      cols: [],
      records: [],
      mCustomers:{},
      sortedcol: -1, 
      fieldsstring: '',
      filterPanel: {
        show: false,
        value:'',
        name:'',
        index:0,
        filterCol: {}
      },
      headlineActions: [],
      showModaleQuote: false,
      titoloQuote: ''
    };
  },
  created: function() {
  },
  mounted: function() {
    this.headlineActions.push({title: 'crea_catalogo', name:'Crea Catalogo', symbol:'add'})
    this.setupRecordFields();
    this.getRecords();
  },
  computed: {},
  watch: {},
  methods: {
    setupRecordFields: function() {
      var ord=1;
      this.cols.push( { order: ord++, value:'', label:'#', name:'Name', type:'string', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Titolo', name:'Titolo__c', type:'string', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Cliente', name:'Account__r.Name', type:'string', issortable: false, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Data Creazione', name:'CreatedDate', type:'date', issortable: true, sortdir:'' } );
      this.cols.push( { order: ord++, value:'', label:'Prezzo Totale', name:'Prezzo_Totale__c', type:'currency', issortable: true, sortdir:'' } );

      var mfields=new Map();
      mfields.set('Id', null);
      this.mapFields(mfields, this.cols);
      this.fieldsstring=this.uniqueFields(mfields).join(',');

    },
    changeSort: function(icol) {
      console.log('changeSort:'+icol)
      if (this.sortedcol!=icol) {
        if (this.sortedcol>=0) this.cols[this.sortedcol].sortdir='';
      }
      this.sortedcol=icol;
      if (this.cols[icol].sortdir=='asc' || !this.cols[icol].sortdir) { this.cols[icol].sortdir='desc'; this.doSort(icol, 'desc'); return; }
      if (this.cols[icol].sortdir=='desc' ) { this.cols[icol].sortdir='asc'; this.doSort(icol, 'asc'); return; }
    },
    doSort: function(icol,dir) {
      console.log('sorting'+icol+dir);
      var self=this;
      var vdir=(dir=='desc'?-1:1);
      this.records.sort(function(a, b) {
        var va=a[self.cols[icol].name];
        var vb=b[self.cols[icol].name];
        if (self.cols[icol].name=="Campagne__c") {
          va=(va?va.split(';').length:0);
          vb=(vb?vb.split(';').length:0);
        }
         if(vb>va) return -1*vdir;
         if(vb<va) return 1*vdir;
        return 0;
      });
    },
    actionClick: function(e) {
      console.log(e);
      switch(e) {
        case 'Crea Catalogo':
          this.showModaleQuote = true
      }
    },
    createQuote() {
      var record = {
        Titolo__c: this.titoloQuote
      }
      apiclient.create(this.$store.getters.connection, 'Quote__c', record)
      .then(resp => {
        console.log('quote', resp)
        this.$router.push( { name: 'Quotazione', params: { id: resp.data.id } } )
      }).catch( e => {
        console.error(e);
      })
    },
    filter: function(index) {
      console.log('filtercc');
      var col=this.cols[index];
      if (col.filtered) {
        col.filtered=false;
        col.filterValue='';
        this.getRecords();
      } else {
        this.filterPanel.index=index;
        this.filterPanel.name=col.label;
        this.filterPanel.filterCol=col;
        this.filterPanel.value='';
        this.filterPanel.show=true;
      }
    }, 
    doFilter: function() {
      var col=this.cols[this.filterPanel.index];
      col.filtered=this.filterPanel.value;
      this.filterPanel.show=false;
      this.getRecords();
    }, 
    getRecords: function() {
      var self=this;
      var filtri=[];
      this.cols.forEach(function(d){
        if (d.filtered)
          filtri.push(d.name+' like \''+d.filtered+'%\'');
      });
      var soql='select '+this.fieldsstring+' from Quote__c';

      // TODO: va inserita la zona sulle quote__c ????
      // filtri.push('Zona_1__c=\''+this.$store.getters.zona+'\'');

      var swhere=' where '+filtri.join(' and ');
      if (filtri.length>0) soql=soql+swhere;

      soql+=' order by CreatedDate DESC';

      console.log(soql);

      apiclient.query(this.$store.getters.connection, soql)
      .then(function(data) {
        console.log('records:'+data.length);
        self.records=data;
        self.busy=false;
      }).catch(function(err){
        console.log(err);
      })
    },
    gotoRecord: function(record) {
      console.log(record);
      this.$router.push({ name:'Quotazione', params: { id: record.Id, record: record } });
    }
  }
}
</script>
